import { render, staticRenderFns } from "./modifyPass.vue?vue&type=template&id=ea3dd896&"
import script from "./modifyPass.vue?vue&type=script&lang=js&"
export * from "./modifyPass.vue?vue&type=script&lang=js&"
import style0 from "./modifyPass.vue?vue&type=style&index=0&id=ea3dd896&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports